import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

export interface Entity {
    guid: string;
    risk_rule: string;
    domain: string;
    status: string;
    update_time: number;
    added_time: number;
    deleted_time: number | null;
    is_external: boolean | null;
    description: string;
    extra_data: Record<string, any>;
    risk_level: number;
    tenant: string | null;
    riskLevel: number;
    init_timestamp: number;
    insight_status: string;
    last_update_timestamp: number;
    domainName: string;
    isDeleted: boolean;
    sAMAccountName: string;
    entityType: number;
    insights: string[];
    hidden_insights: string[];
    identifier: string;
    auth_type: string;
    mail: string;
    is_disabled: boolean | null;
    dn: string;
    services: any[];
    path: string;
    name: string;
    user_with_spn: boolean;
    user_account_control: number | null;
    type: ProtectedEntityType;
    sam: string;
    user_name: string;
}

export enum ProtectedEntityType {
    GROUP = AD_ENTITY_TYPES.GROUP,
    USER = AD_ENTITY_TYPES.USER,
    OU = AD_ENTITY_TYPES.OU
}
